import {Application} from "@hotwired/stimulus"
import {conversations} from "../components/conversations"
import {confirm_read} from "../components/confirm_read"
import {localizeDropzone} from "../components/dropzone_messages"
import BrokenWeekOverrideModalController from "../controllers/broken_week_override_modal_controller"
import CheckboxSelectorController from "../controllers/checkbox_selector_controller"
import PublishConfirmController from "../controllers/publish_confirm_controller"
import ChildrenSelectController from "../controllers/children_select_controller"
import ExpandableRowController from "../controllers/expandable_row_controller"
import WeekNumberSelectorController from "../controllers/week_number_selector_controller"
import PersonnelDaysFilterController from "../controllers/personnel_days_filter_controller"
import SubmitOnceController from "../controllers/submit_once_controller"
import SurveyCampaignController from "../controllers/survey_campaign_controller"
import BillingSourceSearchController from "../controllers/billing_source_search_controller"
import FlashController from "../controllers/flash_controller"
import RichTextEditorController from "../controllers/rich_text_editor_controller"
import PictureDropzoneController from "../controllers/picture_dropzone_controller"

localizeDropzone(window.Dropzone)

const application = Application.start()

// Comment/Uncomment to see stimulus debug logs
application.debug = false

application.register("broken-week-override-modal", BrokenWeekOverrideModalController)
application.register("checkbox-selector", CheckboxSelectorController)
application.register("publish-confirm", PublishConfirmController)
application.register("children-select", ChildrenSelectController)
application.register("expandable-row", ExpandableRowController)
application.register("week-number-selector", WeekNumberSelectorController)
application.register("personnel-days-filter", PersonnelDaysFilterController)
application.register("submit-once", SubmitOnceController)
application.register("survey-campaign", SurveyCampaignController)
application.register("billing-source-search", BillingSourceSearchController)
application.register("flash", FlashController)
application.register("rich-text-editor", RichTextEditorController)
application.register("picture-dropzone", PictureDropzoneController)

// eslint-disable-next-line no-console
console.log("Vite ⚡️ Rails & Jaamo;")

document.addEventListener("turbolinks:load", function (evt) {
  const win = evt.target.defaultView
  const doc = evt.target
  conversations(win, doc)
  confirm_read()
})
